import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import cincoPilares from '../images/cincoPilares.png';
import contacto from '../images/conctacto.png';
import email from '../images/email.png';
import AWS from '../images/poweredByAWS.png';
import ubicacion from '../images/ubicacion.png';


export function Page5() {
    return (
        <Box mt={0} sx={{ flexGrow: 1, p: 4, minHeight: '100vh', color: 'white' }}>
            {/* Título */}
            <Grid container justifyContent="flex-start">
                <Grid size={{ xs: 12, md: 8, lg: 4 }}>
                    <Typography sx={{
                        fontSize: {
                            xs: '24px',   // pantallas pequeñas
                            sm: '24px',   // pantallas ≥600px
                            md: '40px',   // pantallas ≥900px
                            lg: '50px',   // pantallas ≥1200px
                        },
                    }} align="center" gutterBottom>
                        Our 5 pilars
                    </Typography>
                </Grid>
            </Grid>

            <Grid container justifyContent="center" sx={{ mt: 4, mb: 6 }}>
                <Grid size={{ xs: 12, md: 12 }} display="flex" justifyContent="center">
                    <img
                        src={cincoPilares}
                        alt="5 V's Pillars"
                        style={{
                            width: '700px',   // Tamaño deseado
                            maxWidth: '100%', // Asegura que no sobrepase el contenedor en pantallas pequeñas
                            height: 'auto',
                        }}
                    />
                </Grid>
            </Grid>



            {/* Sección de contacto */}

            <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid size={{ xs: 12, md: 8 }} >
                    <Typography sx={{ fontSize: '20px' }} xs={{ fontSize: '20px' }} align="center">
                        To request consulting services or schedule a demo, as well as if you have any questions,
                        comments, or would like to obtain more information, do not hesitate to contact us.
                    </Typography>
                </Grid>


                {/* Línea divisoria */}

                <Divider sx={{ backgroundColor: '#555', mb: 1 }} />
                {/* Línea azul*/}
                <Box
                    sx={{
                        borderTop: '3px solid #A9D4F4',
                        width: '80%',
                        margin: '0 auto',
                        marginBottom: 2
                    }}
                />


                {/*Contactanos */}

                <Grid container justifyContent="center">
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Typography variant="h5" align="center" gutterBottom>
                            Contact Us
                        </Typography>
                    </Grid>
                </Grid>


                {/* Información de contacto */}

                <Grid size={{ xs: 12, md: 8 }}>
                    <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                        <img
                            src={ubicacion} // imagen para ubicacion
                            alt="Ubicación"
                            style={{ height: 20 }}
                        />
                        <Typography>
                            Blvd. Eugenio Garza Sada S/N, Cumbres del Campestre, 37128 León de los Aldama, Gto.
                        </Typography>
                    </Box>

                    <Box display="flex" alignItems="center" justifyContent="center" gap={1} mt={1}>
                        <img
                            src={contacto} // imagen para teléfono
                            alt="contacto"
                            style={{ height: 20 }}
                        />
                        <Typography>
                            MEX: +52 (477) 717 3339 | USA: +1 (469) 902 4711
                        </Typography>
                    </Box>

                    <Box display="flex" alignItems="center" justifyContent="center" gap={1} mt={1}>
                        <img
                            src={email} // imagen para email
                            alt="email"
                            style={{ height: 20 }}
                        />
                        <Typography>
                            info@optimen.com.mx
                        </Typography>
                    </Box>
                </Grid>

                <Grid container spacing={1} pt={2} alignItems="center" size={{ xs: 12 }}>
                    <Grid size={{ xs: 12, md: 12 }} display="flex" justifyContent="center">
                        <a href="https://aws.amazon.com/what-is-cloud-computing">
                            <Box
                                component="img"
                                src={AWS}
                                alt="Icon 4"
                                className="icon-image"
                                sx={{
                                    width: {
                                        xs: '100px',   // Estilo en pantallas pequeñas
                                        md: '200px'    // Estilo en pantallas medianas o mayores
                                    },
                                    height: 'auto',
                                    mx: 'auto',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            />
                        </a>
                    </Grid >
                    <Grid size={{ xs: 12, md: 12 }} display="flex" justifyContent="center">
                        <Typography variant="body1" sx={{ color: '#999' }}>
                            © 2025 nexux-ai
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
